import {
  Box,
  Card,
  CardContent,
  Container,
  Stack,
  Typography,
} from "@mui/material";
import { Button, Checkbox } from "@axismaxlife/unified-ui-components-library";
import { useContext, useEffect, useState } from "react";
import { PageTitle } from "../../commanComponents/PageTitle";
import { String } from "../../constants/Strings";
import { JourneyProgressStepper } from "../../commanComponents/JourneyProgressStepper";
import { colors } from "../../style/color/colors";
import { useLocation, useNavigate } from "react-router-dom";
import { AppToast } from "../../commanComponents/AppToast";
import { goalArray } from "../../constants/GoalArray";
import { DataContext } from "../../Hooks/context/ChildData";
import { useSavingGoals } from "../../api/apiEndpoints/SavingGoals";
import { fonts } from "../../style/fonts/fonts";
import { gaCustomEvent } from "../../logic/CommonFunctions";
import { OTPVerifyContext } from "../../Hooks/context/OTPVeriryContext";

const Goal = () => {
  const [selectedIndex, setSelectedIndex] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarmessage, setSnackbarMessage] = useState({
    message: "",
    severity: "",
  });
  const navigation = useNavigate();
  const { collectData } = useContext(DataContext);
  const { verifyData } = useContext(OTPVerifyContext);
  const location = useLocation();
  const { getGoals } = useSavingGoals();

  const { state } = location;

  useEffect(() => {
    if (state && state.someCondition) {
      fetchDataBasedOnState();
    }
    window.scrollTo(0, 0);
  }, []);
  const fetchDataBasedOnState = async () => {
    try {
      const response = await getGoals({
        userId: state.userId,
      });
      if (response.httpCode === 200) {
        const selectedGoals = response.response.goals;

        const selectedIndices = selectedGoals
          .flatMap((goal) => {
            const matchedIndices = [];

            const titleIndex = goalArray.findIndex(
              (item) => item.Title === goal.goalName,
            );
            if (titleIndex !== -1) {
              matchedIndices.push(titleIndex);
            }

            if (goal.goalId === 2) {
              goalArray.forEach((item, index) => {
                if (item.id === 2 && !matchedIndices.includes(index)) {
                  matchedIndices.push(index);
                }
              });
            }

            return matchedIndices;
          })
          .filter((index, i, arr) => arr.indexOf(index) === i);

        setSelectedIndex(selectedIndices);

        setSnackbarOpen(true);
        setSnackbarMessage({
          message: String.Goal.DataFetchSuccessfully,
          severity: String.successSeverity,
        });
      } else {
        setSnackbarOpen(true);
        setSnackbarMessage({
          message: String.Goal.erroWhileFetching,
          severity: String.ErrorSeverity,
        });
      }
    } catch (error) {
      setSnackbarMessage({
        message: String.Goal.erroWhileFetching,
        severity: String.ErrorSeverity,
      });
      setSnackbarOpen(true);
    }
  };

  const handleCardClick = (index) => {
    gaCustomEvent(
      String.gaEventName.acrPortfolio,
      String.gaEventClickName.acrPortfolioFinancialGoals,
      verifyData.customerId,
    );

    setSelectedIndex((prevSelect) => {
      if (prevSelect.includes(index)) {
        return prevSelect.filter((i) => i !== index);
      } else {
        return [...prevSelect, index];
      }
    });
  };

  const navigateToSave = (selectedGoals, multiGoal, hasChildGoal) => {
    const navigateToChildPlanning = (childPlanningData) => {
      return navigation(String.navigations.childquestion, {
        state: {
          childPlanningData,
          multipleGoal: multiGoal,
          hasChildGoal,
        },
      });
    };

    if (selectedGoals.length === 1 && selectedGoals[0] === 1) {
      return navigateToChildPlanning(false);
    }
    else if (
      selectedGoals.includes(1) &&
      selectedGoals.includes(2) &&
      selectedGoals.includes(2) &&
      selectedGoals.includes(5) &&
      selectedGoals.includes(4)
    ) {
      return navigateToChildPlanning(true);
    }
    else if (
      selectedGoals.includes(1) &&
      selectedGoals.includes(2) &&
      selectedGoals.includes(2) &&
      selectedGoals.includes(4)
    ) {
      return navigateToChildPlanning(true);
    }
    else if (
      selectedGoals.includes(1) &&
      selectedGoals.includes(2) &&
      selectedGoals.includes(2) &&
      selectedGoals.includes(5)
    ) {
      return navigateToChildPlanning(true);
    }
    else if (
      selectedGoals.includes(1) &&
      (selectedGoals.includes(4) || selectedGoals.includes(5))
    ) {
      return navigateToChildPlanning(false);
    }

    else if (
      selectedGoals.includes(1) ||
      selectedGoals.includes(2) ||
      selectedGoals.includes(2)
    ) {
      return navigateToChildPlanning(true);
    }

    else if (selectedGoals.includes(5)) {
      return navigation(String.navigations.retirementgoal);
    }

    else if (selectedGoals.includes(4)) {
      return navigation(String.navigations.investmentgoal);
    }

    else {
      setSnackbarOpen(true);
      setSnackbarMessage(String.Goal.unknownGoalSelected);
    }
  };

  const saveGoal = async () => {
    gaCustomEvent(
      String.gaEventName.acrPortfolio,
      String.gaEventClickName.acrPortfolioFinancialGoalsContinue,
      verifyData.customerId,
    );

    if (selectedIndex.length === 0) {
      setSnackbarOpen(true);
      setSnackbarMessage({
        message: String.Goal.atleastGoalSelection,
        severity: String.ErrorSeverity,
      });
      return;
    }

    const selectedGoalsIndex = selectedIndex.map((index) => goalArray[index]);

    const selectedGoals = [
      ...new Set(selectedGoalsIndex.map((goal) => goal.id)),
    ].sort((a, b) => a - b);

    const hasChildGoal = selectedIndex.some(
      (idx) =>
        goalArray[idx]?.id === 2 ||
        goalArray[idx]?.Title?.toLowerCase().includes("child"),
    );

    let multiGoal = selectedGoals.length > 1;

    collectData({
      selectedGoals: selectedGoals.includes(2)
        ? [...selectedGoals, 3]
        : selectedGoals,
      hasChildGoal,
    });

    setSnackbarOpen(true);
    setSnackbarMessage({
      message: String.Goal.goalSave,
      severity: String.successSeverity,
    });

    setTimeout(() => {
      setSnackbarOpen(false);

      navigateToSave(selectedGoals, multiGoal, hasChildGoal);
    }, 2000);
  };
  return (
    <Container>
      <PageTitle />
      <JourneyProgressStepper />
      <Typography
        sx={{
          mt: "24px",
          fontSize: "13px",
          fontFamily: fonts.notoSans,
          fontWeight: 500,
          color: colors.NeutralDark700,
        }}
      >
        {String.Goal.selectGoalsHeading}
      </Typography>
      <Stack
        spacing="16px"
        sx={{
          width: "100%",
          height: "100%",
          mt: "16px",
          mb: "10px",
          overflowY: "auto",
        }}
      >
        {goalArray.map((item, index) => {
          const IsSelected = selectedIndex.includes(index);
          return (
            <Card
              key={index}
              elevation={0}
              sx={{
                minWidth: 275,
                borderRadius: "12px",
                boxShadow: "none",
                border: IsSelected
                  ? `1px solid ${colors.SecondarySummerSky}`
                  : `1px solid ${colors.lavendershade}`,
                color: IsSelected
                  ? colors.SecondarySummerSky
                  : colors.NeutralDark700,
                backgroundColor: IsSelected
                  ? colors.ExtendedPalettesSummerSkySS100
                  : colors.PrimaryWhite,
                cursor: "pointer",
              }}
              onClick={() => handleCardClick(index)}
            >
              <CardContent
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <Box
                  sx={{
                    flexShrink: 0,
                    maxWidth: "100%",
                    height: "auto",
                  }}
                >
                  {item.goalSVG && (
                    <Box
                      component="img"
                      src={item.goalSVG}
                      alt=""
                      aria-hidden="true"
                      sx={{ display: "block", width: "43px", height: "auto" }}
                    />
                  )}
                </Box>
                <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: "16px",
                        fontFamily: fonts.notoSans,
                        fontWeight: "400",
                        color: IsSelected
                          ? colors.SecondarySummerSky
                          : colors.PrimaryWoodSmoke,
                      }}
                    >
                      {item.Title}
                    </Typography>
                    <Box
                      sx={{ flexShrink: 0 }}
                      onClick={(event) => event.stopPropagation()}
                    >
                      <Checkbox
                        checked={IsSelected}
                        onChange={() => handleCardClick(index)}
                        ariaLabel={item.Title}
                        label=""
                      />
                    </Box>
                  </Box>
                  <Typography
                    variant="body2"
                    sx={{
                      mt: "4px",
                      fontSize: "13px",
                      fontFamily: fonts.notoSans,
                      fontWeight: 400,
                      color: colors.NeutralDark600,
                    }}
                  >
                    {item.description}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          );
        })}
      </Stack>

      <Box sx={{ mt: "40px", mb: "40px" }}>
        <Button
          buttonType="primary"
          width="100%"
          disabled={selectedIndex.length === 0}
          onClick={saveGoal}
        >
          {String.continue}
        </Button>
      </Box>
      <AppToast
        open={snackbarOpen}
        handleClose={() => {
          setSnackbarOpen(false);
        }}
        message={snackbarmessage.message}
        severity={snackbarmessage.severity}
      />
    </Container>
  );
};

export default Goal;
